var _rect, _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _path4, _line7, _line8, _line9, _line0, _line1, _line10, _mask, _rect2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "outline outline--stroke",
    x: 13,
    y: 3,
    width: 22,
    height: 42,
    rx: 1,
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline outline--stroke",
    d: "M10 40H4C2.89543 40 2 39.1046 2 38V10C2 8.89543 2.89543 8 4 8H10",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "outline outline--stroke",
    d: "M38 40H44C45.1046 40 46 39.1046 46 38V10C46 8.89543 45.1046 8 44 8H38",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "outline outline--stroke",
    d: "M10 21C7.79086 21 6 19.2091 6 17C6 14.7909 7.79086 13 10 13",
    stroke: "#C5CAD1",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "highlight highlight--stroke",
    x1: 18,
    y1: 27,
    x2: 30,
    y2: 27,
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "highlight highlight--stroke",
    x1: 18,
    y1: 31,
    x2: 30,
    y2: 31,
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "highlight highlight--stroke",
    x1: 18,
    y1: 35,
    x2: 30,
    y2: 35,
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 7,
    y1: 25,
    x2: 9,
    y2: 25,
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 7,
    y1: 28,
    x2: 9,
    y2: 28,
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 7,
    y1: 31,
    x2: 9,
    y2: 31,
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "outline outline--stroke",
    d: "M38 21C40.2091 21 42 19.2091 42 17C42 14.7909 40.2091 13 38 13",
    stroke: "#C5CAD1",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 1,
    y1: -1,
    x2: 3,
    y2: -1,
    transform: "matrix(-1 0 0 1 42 26)",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 1,
    y1: -1,
    x2: 3,
    y2: -1,
    transform: "matrix(-1 0 0 1 42 29)",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 1,
    y1: -1,
    x2: 3,
    y2: -1,
    transform: "matrix(-1 0 0 1 42 32)",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "highlight highlight--stroke",
    x1: 21,
    y1: 39,
    x2: 27,
    y2: 39,
    stroke: "#FFD200",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 7,
    y1: 34,
    x2: 9,
    y2: 34,
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "outline outline--stroke",
    x1: 1,
    y1: -1,
    x2: 3,
    y2: -1,
    transform: "matrix(-1 0 0 1 42 35)",
    stroke: "#C5CAD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 14,
    height: 14,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "highlight highlight--stroke",
    x: 17,
    y: 8,
    width: 14,
    height: 14,
    rx: 1,
    stroke: "#FFD200",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-18-inside-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "highlight highlight--fill",
    d: "M23.4142 12.5858C22.6332 11.8047 21.3668 11.8047 20.5858 12.5858C19.8047 13.3668 19.8047 14.6332 20.5858 15.4142L23.4142 12.5858ZM24 16L22.5858 17.4142C23.3668 18.1953 24.6332 18.1953 25.4142 17.4142L24 16ZM27.4142 15.4142C28.1953 14.6332 28.1953 13.3668 27.4142 12.5858C26.6332 11.8047 25.3668 11.8047 24.5858 12.5858L27.4142 15.4142ZM20.5858 15.4142L22.5858 17.4142L25.4142 14.5858L23.4142 12.5858L20.5858 15.4142ZM25.4142 17.4142L27.4142 15.4142L24.5858 12.5858L22.5858 14.5858L25.4142 17.4142Z",
    fill: "#FFD200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.c44eae2764c7468daa3eae0eb76e0309.svg";
export { ForwardRef as ReactComponent };